(function () {
  'use strict';

  angular.module('app').component('providersPage', providerListComponent());

  function providerListComponent() {
    return {
      bindings: {},
      controller: ProviderListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/providers/providers-page.component.html',
    };
  }

  ProviderListCtrl.$inject = ['$location', 'AbilityService', 'ProviderService'];

  function ProviderListCtrl($location, AbilityService, ProviderService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_provider_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      ProviderService.getProviders().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/providers/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/providers/${item.id}`).search({ mode: mode });
    }
  }
})();
